import React from 'react';
import SettingsIcon from '@material-ui/icons/Settings';
import {
    CustomBreadcrumbs,
    CustomList,
    CustomFilter,
    CustomSelectInput,
} from 'candy-commons-components';
import { TextField } from 'react-admin';
import DynamoPagination from '../../components/DynamoPagination';
import CustomDatagrid from '../../components/organisms/customDatagrid';
import applianceConfigurationTypes from './constants/applianceConfigurationTypes';
const breadcrumbsData = [
    {
        text: 'App Configuration',
        url: '',
        icon: <SettingsIcon />,
    },
];
// "Custom" is only a create option: custom entries are saved with their own type name
const typeChoices = applianceConfigurationTypes.filter(
    ({ id }) => id !== 'custom'
);
// Filter by type: exact match, applied by the backend
const AppConfigurationFilter = (props) => (
    <CustomFilter {...props}>
        <CustomSelectInput
            label="Type"
            source="type"
            choices={typeChoices}
            allowEmpty
            alwaysOn
        />
    </CustomFilter>
);
const AppConfigurationList = ({ permissions, ...props }) => (
    <>
        <CustomBreadcrumbs data={breadcrumbsData} />
        <CustomList
            perPage={25}
            exporter={false}
            pagination={<DynamoPagination resource="app-configuration" />}
            {...props}
            filters={<AppConfigurationFilter />}
            bulkActionButtons={
                permissions &&
                permissions['app-configuration'] &&
                permissions['app-configuration'].delete
            }
        >
            <CustomDatagrid selectable rowClick="edit">
                <TextField source="type" />
                <TextField source="key" />
                <TextField source="value" />
            </CustomDatagrid>
        </CustomList>
    </>
);
export default AppConfigurationList;
